/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const ptMessages = {
    /* 01.General */
    /* 02.User Login, Logout, Register */
    'user.login-title': 'Iniciar sessão',
    'user.register': 'Registar',
    'user.forgot-password': 'Esqueceu‑se da palavra‑passe?',
    'user.email': 'E‑mail',
    'user.newpassword': 'Nova palavra‑passe',
    'user.currentpassword': 'Palavra‑passe atual',
    'user.newpasswordagain': 'Nova palavra‑passe (verificar)',
    'user.password': 'Palavra‑passe',                  // a palavra‑passe :contentReference[oaicite:0]{index=0}
    'user.forgot-password-question': 'Esqueceu‑se da palavra‑passe?',
    'user.fullname': 'Nome completo',
    'user.firstname': 'Nome',
    'user.lastname': 'Apelido',
    'user.login-button': 'INICIAR SESSÃO',
    'user.register-button': 'REGISTAR',
    'user.reset-password-button': 'REDEFINIR',
    'user.buy': 'COMPRAR',
    'user.username': 'Nome de utilizador',             // nome de utilizador :contentReference[oaicite:1]{index=1}

    /* 03.Menu */
    'menu.app': 'Início',
    'menu.online': 'Online',
    'menu.offline': 'Offline',
    'menu.default': 'Predefinido',
    'menu.analytics': 'Análises',
    'menu.ecommerce': 'E‑commerce',
    'menu.content': 'Conteúdos',
    'menu.pages': 'Páginas',
    'menu.data-list': 'Lista de dados',
    'menu.thumb-list': 'Lista em miniaturas',
    'menu.image-list': 'Lista de imagens',
    'menu.details': 'Detalhes',
    'menu.search': 'Pesquisar',
    'menu.login': 'Iniciar sessão',
    'menu.register': 'Registar',
    'menu.forgot-password': 'Esqueceu‑se da palavra‑passe?',
    'menu.error': 'Erro',
    'menu.applications': 'Aplicações',
    'menu.todo': 'Lista de tarefas',
    'menu.survey': 'Inquérito',
    'menu.chat': 'Chat',
    'menu.ui': 'UI',
    'menu.edit': 'Editar',
    'menu.alerts': 'Alertas',
    'menu.badges': 'Distintivos',
    'menu.buttons': 'Botões',
    'menu.cards': 'Cartões',
    'menu.carousel': 'Carrossel',
    'menu.charts': 'Gráficos',
    'menu.collapse': 'Colapsar',
    'menu.dropdowns': 'Menus suspensos',
    'menu.editors': 'Editores',
    'menu.form-layouts': 'Layout de formulários',
    'menu.form-components': 'Componentes de formulários',
    'menu.form-validations': 'Validações de formulários',
    'menu.icons': 'Ícones',
    'menu.input-groups': 'Grupos de entrada',
    'menu.jumbotron': 'Jumbotron',
    'menu.modal': 'Modal',
    'menu.navigation': 'Navegação',
    'menu.popover-tooltip': 'Popover & Tooltip',
    'menu.sortable': 'Ordenável',
    'menu.tables': 'Tabelas',
    'menu.menu': 'Menu',
    'menu.subhidden': 'Suboculto',
    'menu.hidden': 'Oculto',
    'menu.visible': 'Visível',
    'menu.maps': 'Mapas',
    'menu.landingpage': 'Página de aterragem',
    'menu.multipage-home': 'Página inicial multipágina',
    'menu.singlepage-home': 'Página inicial monocpage',
    'menu.about': 'Sobre',
    'menu.auth-login': 'Autenticar (login)',
    'menu.auth-register': 'Autenticar (registo)',
    'menu.blog': 'Blogue',
    'menu.blog-detail': 'Detalhe do blogue',
    'menu.careers': 'Carreiras',
    'menu.confirmation': 'Confirmação',
    'menu.contact': 'Contacto',
    'menu.docs': 'Documentação',
    'menu.features': 'Funcionalidades',
    'menu.prices': 'Preços',
    'menu.videos': 'Vídeos',
    'menu.mailing': 'Mailing',
    'menu.invoice': 'Fatura',
    'menu.blank-page': 'Brevemente...',
    'menu.types': 'Tipos de Menu',
    'menu.levels': 'Níveis de Menu',
    'menu.third-level-1': 'Terceiro Nível 1',
    'menu.third-level-2': 'Terceiro Nível 2',
    'menu.third-level-3': 'Terceiro Nível 3',

    /* 04.Dashboards */

    'dashboards.update': 'Atualizar',
    'dashboards.save': 'Guardar',
    'dashboards.name': 'Nome',
    'dashboards.button': 'Botão',
    'dashboards.visits': 'Visitas',
    'dashboards.checkAvailability': 'Verificar disponibilidade ou tarifas',
    'dashboards.details': 'Detalhes',
    'dashboards.pending-orders': 'Encomendas pendentes',
    'dashboards.completed-orders': 'Encomendas concluídas',
    'dashboards.refund-requests': 'Pedidos de reembolso',
    'dashboards.new-comments': 'Novos comentários',
    'dashboards.sales': 'Vendas',
    'dashboards.orders': 'Encomendas',
    'dashboards.refunds': 'Reembolsos',
    'dashboards.recent-orders': 'Encomendas recentes',
    'dashboards.product-categories': 'Categorias de produtos',
    'dashboards.cakes': 'Bolhos',
    'dashboards.tickets': 'Bilhetes',
    'dashboards.calendar': 'Calendário',
    'dashboards.best-sellers': 'Mais vendidos',
    'dashboards.per-session': 'Por sessão',
    'dashboards.profile-status': 'Estado do perfil',
    'dashboards.payment-status': 'Estado do pagamento',
    'dashboards.work-progress': 'Progresso do trabalho',
    'dashboards.tasks-completed': 'Tarefas concluídas',
    'dashboards.payments-done': 'Pagamentos efetuados',
    'dashboards.order-stock': 'Encomendar – Stock',
    'dashboards.categories': 'Categorias',
    'dashboards.quick-post': 'Publicação rápida',
    'dashboards.title': 'Título',
    'dashboards.content': 'Conteúdo',
    'dashboards.ticket-count': 'Contagem de bilhetes',
    'dashboards.commonticketsubmission': 'Submissões comuns de bilhetes',
    'dashboards.category': 'Categoria',

    'dashboards.save-and-publish': 'Guardar e publicar',
    'dashboards.top-viewed-posts': 'Publicações mais visualizadas',
    'dashboards.posts': 'Publicações',
    'dashboards.pending-for-publish': 'Pendente de publicação',
    'dashboards.users': 'Utilizadores',
    'dashboards.on-approval-process': 'Em processo de aprovação',
    'dashboards.alerts': 'Alertas',
    'dashboards.waiting-for-notice': 'A aguardar aviso',
    'dashboards.files': 'Ficheiros',
    'dashboards.pending-for-print': 'Pendente de impressão',
    'dashboards.logs': 'Registos',
    'dashboards.gogo': 'GOGO',
    'dashboards.magic-is-in-the-details': 'A MAGIA ESTÁ NOS DETALHES',
    'dashboards.yes-it-is-indeed': 'Sim, é mesmo!',
    'dashboards.advanced-search': 'Pesquisa avançada',
    'dashboards.toppings': 'Coberturas',
    'dashboards.type': 'Tipo',
    'dashboards.keyword': 'Palavra-passe‑chave',
    'dashboards.search': 'Pesquisar',
    'dashboards.top-rated-items': 'Itens melhor classificados',
    'dashboards.country': 'País',
    'dashboards.webVisitors': 'Visitantes web',
    'dashboards.avatarClicks': 'Cliques no avatar',
    'dashboards.wordCloud': 'Nuvem de palavras',
    'dashboards.topic': 'Tópico',
    'dashboards.roomsAvailability': 'Quartos e disponibilidade',
    'dashboards.startChat': 'Iniciar chat',
    'dashboards.restaurantsBars': 'Restaurantes & Bares',
    'dashboards.groupBooking': 'Reserva de grupo',
    'dashboards.promotions': 'Promoções',
    'dashboards.weedingevents': 'Casamentos & Eventos',
    'dashboards.lostsomething': 'Perdeu algo',
    'dashboards.producttext': 'Texto do produto',
    'dashboards.bookingroomnew': 'Nova reserva de quarto',
    'dashboards.email': 'E‑mail',
    'dashboards.phone': 'Telefone',
    'dashboards.zipcode': 'Código postal',
    'dashboards.marketingconsent': 'Consentimento para marketing',
    'dashboards.additionalinfo': 'Informação adicional',
    'dashboards.viewallcontacts': 'Ver todos os contactos',
    'dashboards.current': 'Atual',
    'dashboards.last7days': 'Últimos 7 dias',
    'dashboards.last30days': 'Últimos 30 dias',
    'dashboards.thisweek': 'Esta semana',
    'dashboards.thismonth': 'Este mês',
    'dashboards.previousmonth': 'Mês anterior',
    'dashboards.yeartodate': 'Ano até à data',
    'dashboards.lastyear': 'Ano passado',
    'dashboards.all': 'Todos',
    'dashboards.standardOccupancy': 'Ocupação standard',
    'dashboards.max-occupancy': 'Ocupação máxima',
    'dashboards.numberOfThisType': 'Número deste tipo',
    'dashboards.displayOrder': 'Ordem de exibição',
    'dashboards.provider': 'Prestador',
    'dashboards.edit': 'Editar',
    'dashboards.delete': 'Eliminar',
    'dashboards.addImages': 'Adicionar imagens',
    'dashboards.near': 'Perto',
    'dashboards.calling_party': 'Utilizador que liga',
    'dashboards.called_party': 'Utilizador chamado',
    'dashboards.lastdial': 'Última chamada',
    'dashboards.imagelink': 'Link da imagem',
    'dashboards.browsegallery': 'Explorar galeria',
    'dashboards.changelog': 'Log de alterações',
    'dashboards.externalresources': 'Recursos externos',
    'dashboards.webpage': 'Página web',
    'dashboards.web-pages': 'Páginas web',
    'dashboards.published': 'Publicado',
    'dashboards.adddocument': 'Adicionar documento',
    'dashboards.ready-to-publish': 'Pronto para publicar',
    'dashboards.draft': 'Rascunho',
    'dashboards.order-by': 'Ordenar por',
    'dashboards.add-faq': 'Adicionar FAQ',
    'dashboards.collections': 'Coleções',

    'dashboards.items': 'Itens',
    'dashboards.rooms-availability': 'Quartos & Disponibilidade',
    'dashboards.events-wedding-venues': 'Eventos & Espaços para casamentos',
    'dashboards.long-stay-enquiry': 'Pedido de estadia prolongada',
    'dashboards.reservation-confirmation-request': 'Pedido de confirmação de reserva',
    'dashboards.modify-cancel-booking': 'Modificar ou cancelar reserva',
    'dashboards.left-something-behind': 'Deixou algo para trás',
    'dashboards.invoice-copy': 'Cópia da fatura/recibo',
    'dashboards.sync': 'Sincronizar',
    'dashboards.add-web-page': 'Adicionar página web',
    'dashboards.sprint-title': 'Conheça o Sprint, a nossa automação revolucionária para treinar modelos de IA 10× mais rápido.',
    'dashboards.sprint-description': 'O Sprint trabalha consigo — desbloqueando criatividade, produtividade e reduzindo drasticamente o tempo necessário para treinar o Assistente Digital.',
    'dashboards.sprint-feature': 'A funcionalidade Sprint sincroniza conhecimentos de fontes externas, sendo útil tanto para a configuração inicial como para atualizações contínuas. Quando executado num sistema ativo, o Sprint modifica o Knowledge Hub com base nas suas fontes externas configuradas, influenciando diretamente os comportamentos gerados por IA. Para assistência com a configuração do Sprint, por favor contacte a nossa equipa de suporte.',
    'dashboards.change-password': 'Alterar palavra‑passe',
    'dashboards.sign-out': 'Terminar sessão',
    'dashboards.privacy-policy': 'Política de privacidade',
    'dashboards.help-center': 'Centro de ajuda',
    'dashboards.switch-account': 'Alterar conta',
    'dashboards.business-settings': 'Configurações empresariais',
    'dashboards.notifications-allowed': 'Notificações permitidas',
    'dashboards.dark-theme': 'Tema escuro',
    'dashboards.online': 'Online',
    'dashboards.offline': 'Offline',
    'dashboards.invoice-&-payments': 'Faturas & Pagamentos',
    'dashboards.upgrade-plan': 'Melhorar plano',
    'dashboards.add-room': 'Adicionar Quarto',
    'dashboards.room-type': 'Tipo de Quarto',
    'dashboards.room-name': 'Nome do Quarto',
    'dashboards.how-many-guests': 'Quantos hóspedes podem ficar neste quarto?',
    'dashboards.number-of-rooms-this-type': 'Número de quartos (deste tipo)',
    'dashboards.number-of-bedrooms': 'Número de quartos',
    'dashboards.number-of-livingrooms': 'Número de salas de estar',
    'dashboards.minimum-adults': 'Mínimo de Adultos',
    'dashboards.maximum-adults': 'Máximo de Adultos',
    'dashboards.maximum-children': 'Máximo de Crianças',
    'dashboards.maximum-infants': 'Máximo de Bebês',
    'dashboards.extra-beds-allowed': 'Camas extras permitidas',
    'dashboards.booking-engine-code': 'Código do Motor de Reservas',
    'dashboards.room-size': 'Tamanho do Quarto',
    'dashboards.balcony-area': 'Área da Varanda',
    'dashboards.unit': 'Unidade',
    'dashboard.whatsapp_message': 'Escreva a sua mensagem aqui...',
    'dashboard.whatsapp_reply_window': 'Dispõe de uma janela de 24 horas para responder a uma mensagem de um cliente no WhatsApp Business a partir do momento em que o cliente enviou a última mensagem. Se responder dentro desta janela de atendimento ao cliente de 24 horas, pode enviar qualquer tipo de mensagem. Após o encerramento da janela de 24 horas, só poderá enviar mensagens utilizando Modelos de Mensagem pré-aprovados, que reiniciam a janela de 24 horas quando o cliente responde.',
    'dashboards.square-meters': 'Metros Quadrados',
    "dashboard.pick_quick_reply": "Escolha uma resposta rápida ou escreva a sua mensagem",
    "dashboard.hang_in_there": "Aguarde enquanto tentamos ligá-lo!",
    "dashboard.outbound_msg": "Quando enviar a mensagem de saída",
    "dashboard.message_sent": "A sua mensagem foi enviada com sucesso!",
    "dashboard.failed_msg": "Falha ao enviar a mensagem",
    "dashboard.new_chat_message": "Nova mensagem de chat",
    "dashboard.user_msg": "Existe uma mensagem do utilizador nas últimas 24 horas. Pode responder com qualquer mensagem. Ainda deseja enviar esta mensagem de modelo ou responder com outra mensagem?",
    "dashboard.us_number": "As mensagens do WhatsApp Business não estão a ser enviadas para números dos EUA porque a Meta suspendeu todas as mensagens de marketing para números dos EUA a 1 de abril de 2025.",
    "dashboard.error_msg": "Por favor, preencha corretamente todos os espaços reservados.",

    'web-widget.title': 'Menus de widget web para o chatbot do site',
    /* Home Page */
    'dashboards.quickstartwithai': 'Arranque rápido com IA',
    'dashboards.fastestpathtoautomation': 'Está no caminho mais rápido para a automatização com ferramentas de IA',
    'dashboards.insightsthatempower': 'Conhecimento que empodera',
    'dashboards.trainchatbot': 'Treinar chatbot',
    'dashboards.automatewithforms': 'Automatizar com formulários',
    'dashboards.inroomdigitalcompendium': 'Compêndio digital no quarto',
    'dashboards.support': 'Suporte',
    'dashboards.helpcenter': 'Centro de ajuda',
    'dashboards.searchfaqintegrations': 'Pesquisar artigos sobre FAQ, integrações e mais.',
    'dashboards.asklivechat': 'Pergunte à nossa equipa via chat ao vivo',
    'dashboards.inroomqrcode': 'QR code no quarto para consultar informações sobre o hotel e localização',
    'dashboards.customizewebwidget': 'Personalizar e adicionar widget web com chatbot de IA ao seu site',
    'dashboards.createcustomforms': 'Criar formulários personalizados e receber notificações quando um hóspede submeter um',
    'dashboards.trainchatbotproperty': 'Treinar chatbot com informações sobre o seu imóvel, como hora de check‑in, atividades, etc.',
    'dashboards.chatbotinsights': 'Ver como o chatbot interage com os hóspedes e obter insights como visitantes do site, perguntas frequentes e muito mais.',
    'dashboards.addaichatbottoyourwebsite': 'Adicionar chatbot de IA ao seu site',

    /* Email Stats  */
    'dashboards.thread-summary-title': 'Resumos de conversas',
    'dashboards.thread-summary-subtitle': 'Resumos de e‑mail gerados por IA',
    'dashboards.ai-replies-title': 'Respostas de IA',
    'dashboards.ai-replies-subtitle': 'Respostas geradas por IA',

    'dashboards.total-thread-summary-title': 'Total de resumos de conversas gerados',
    'dashboards.total-ai-replies-title': 'Total de respostas de IA geradas',
    'dashboards.total-draft-copied': 'Rascunho copiado pelos utilizadores',

    'dashboards.urgency': 'Urgência',
    'dashboards.sentiment': 'Sentimento',

    'dashboards.common-email-reasons': 'Motivos comuns em e‑mails',
    'dashboards.topics-in-emails': 'Tópicos em e‑mails',

    'dashboards.email-assistant-usage': 'Utilização do assistente de e‑mail IA',
    'dashboards.usage-by-email-address': 'Utilização por e‑mail',

    /* 05.Pages */
    'pages.title.dashboards.analytics': 'Análises',
    'pages.title.ari': 'Disponibilidade e tarifas',
    'pages.title.conversations': 'Conversas',
    'pages.title.bookings': 'Reservas',
    'pages.title.tickets': 'Leads e bilhetes',
    'pages.title.propinfo': 'Respostas',
    'pages.title.discounts': 'Descontos e promoções',
    'pages.title.finance': 'Finanças',
    'pages.title.integration': 'Integração',
    'pages.title.admin': 'Admin',
    'pages.add-new': 'ADICIONAR NOVO',
    'pages.add-new-modal-title': 'Adicionar novo item',
    'pages.display-options': 'Opções de visualização',
    'pages.orderby': 'Ordenar por:',
    'pages.product-name': 'Nome do produto',
    'pages.category': 'Categoria',
    'pages.description': 'Descrição',
    'pages.status': 'Estado',
    'pages.cancel': 'Cancelar',
    'pages.submit': 'Submeter',
    'pages.delete': 'Eliminar',
    'pages.another-action': 'Outra ação',
    'pages.actions': 'AÇÕES',
    'pages.header': 'Cabeçalho',
    'pages.details': 'DETALHES',
    'pages.orders': 'ENCOMENDAS',
    'pages.rating': 'Classificação',
    'pages.price': 'Preço',
    'pages.ingredients': 'Ingredientes',
    'pages.is-vegan': 'É vegan?',
    'pages.order-status': 'Estado da encomenda',
    'pages.bake-progress': 'Progresso da cozedura',
    'pages.popularity': 'Popularidade',
    'pages.comments': 'Comentários',
    'pages.error-title': 'Ups… parece que ocorreu um erro!',
    'pages.error-code': 'Código de erro',
    'pages.go-back-home': 'VOLTE PARA INÍCIO',
    'pages.mailing-info': 'Os modelos de mailing usam estilos inline e layout em tabela para serem bem exibidos em vários provedores. Para melhor usabilidade, incluem‑se como HTML regular com dangerouslySetInnerHTML.',
    'pages.invoice-info': 'O modelo de fatura tem uma versão com estilos inline para uso externo ao projeto, bem como versão React.',
    'pages.react-version': 'Versão React',
    'pages.inline-version': 'Versão HTML com estilos inline',

    /* 06.Applications */

    /* 06.01.Chat */
    'chat.messages': 'Mensagens',
    'chat.contacts': 'Contactos',
    'chat.saysomething': 'Diga algo...',

    /* 06.02.Survey */
    'survey.delete': 'Eliminar',
    'survey.edit': 'Editar',
    'survey.add-new': 'ADICIONAR NOVO',
    'survey.add-new-title': 'Adicionar novo inquérito',
    'survey.title': 'Título',
    'survey.category': 'Categoria',
    'survey.label': 'Etiqueta',
    'survey.status': 'Estado',
    'survey.cancel': 'Cancelar',
    'survey.submit': 'Submeter',
    'survey.another-action': 'Outra ação',
    'survey.display-options': 'Opções de visualização',
    'survey.orderby': 'Ordenar por:',
    'survey.all-surveys': 'Todos os inquéritos',
    'survey.completed-surveys': 'Inquéritos concluídos',
    'survey.categories': 'Categorias',
    'survey.active-surveys': 'Inquéritos ativos',
    'survey.labels': 'Etiquetas',

    /* 06.03.Todo */
    'todo.add-new': 'ADICIONAR NOVO',
    'todo.add-new-title': 'Adicionar nova tarefa',
    'todo.title': 'Título',
    'todo.detail': 'Detalhe',
    'todo.category': 'Categoria',
    'todo.label': 'Etiqueta',
    'todo.status': 'Estado',
    'todo.cancel': 'Cancelar',
    'todo.submit': 'Submeter',
    'todo.action': 'Ação',
    'todo.another-action': 'Outra ação',
    'todo.display-options': 'Opções de visualização',
    'todo.orderby': 'Ordenar por:',
    'todo.all-tasks': 'Todas as tarefas',
    'todo.pending-tasks': 'Tarefas pendentes',
    'todo.completed-tasks': 'Tarefas concluídas',
    'todo.categories': 'Categorias',
    'todo.labels': 'Etiquetas',


    /* 07.UI */

    /* 07.01. Alerts */
    'alert.rounded': 'Alerta arredondado',
    'alert.react-notifications': 'Notificações React',
    'alert.outline': 'Contorno',
    'alert.primary': 'Primário',
    'alert.secondary': 'Secundário',
    'alert.info': 'Informação',
    'alert.success': 'Sucesso',
    'alert.warning': 'Aviso',
    'alert.error': 'Erro',
    'alert.filled': 'Preenchido',
    'alert.primary-text': 'Este é um alerta primário — vê só!',
    'alert.secondary-text': 'Este é um alerta secundário — vê só!',
    'alert.success-text': 'Este é um alerta de sucesso — vê só!',
    'alert.danger-text': 'Este é um alerta de perigo — vê só!',
    'alert.warning-text': 'Este é um alerta de aviso — vê só!',
    'alert.info-text': 'Este é um alerta informativo — vê só!',
    'alert.light-text': 'Este é um alerta claro — vê só!',
    'alert.dark-text': 'Este é um alerta escuro — vê só!',
    'alert.default': 'Alerta predefinido',
    'alert.dismissing': 'Alerta descartável',
    'alert.dismissing-text':
        'Uau! Deverias verificar alguns dos campos abaixo.',
    'alert.dismissing-without-animate-text':
        'Sou um alerta que pode ser dispensado sem animação!',

    /* 07.02. Badges */
    'badge.sizes': 'Tamanhos',
    'badge.colors': 'Cores',
    'badge.outline': 'Contorno',
    'badge.links': 'Links',
    'badge.counter-badges': 'Marcadores com contador',
    'badge.bootstrap-default': 'Bootstrap predefinido',
    'badge.primary': 'Primário',
    'badge.secondary': 'Secundário',
    'badge.success': 'Sucesso',
    'badge.danger': 'Perigo',
    'badge.warning': 'Aviso',
    'badge.info': 'Informação',
    'badge.light': 'Claro',
    'badge.dark': 'Escuro',

    /* 07.03. Buttons */
    'button.default': 'Bootstrap predefinido',
    'button.colors': 'Cores',
    'button.rounded': 'Arredondado',
    'button.outline': 'Contorno',
    'button.states': 'Estados',
    'button.sizes': 'Tamanhos',
    'button.button-groups': 'Grupos de botões',
    'button.large-button': 'Botão grande',
    'button.small-button': 'Botão pequeno',
    'button.extra-small-button': 'Botão muito pequeno',
    'button.block-button': 'Botão em bloco',
    'button.active': 'Ativo',
    'button.disabled': 'Desativado',
    'button.basic': 'Básico',
    'button.toolbar': 'Barra de ferramentas',
    'button.nesting': 'Aninhamento',
    'button.vertical-variation': 'Variação vertical',
    'button.checkbox-radio-button': 'Checkbox e Radio',
    'button.checkbox': 'Checkbox',
    'button.radio': 'Radio',
    'button.radio-button': 'Botão de rádio',
    'button.primary': 'Primário',
    'button.secondary': 'Secundário',
    'button.success': 'Sucesso',
    'button.danger': 'Perigo',
    'button.warning': 'Aviso',
    'button.info': 'Informação',
    'button.light': 'Claro',
    'button.dark': 'Escuro',
    'button.states-text':
        'Este botão mostra um spinner durante 2 segundos e um ícone de erro durante 3 segundos antes de voltar ao estado normal. Estes estados podem ser ativados removendo ou adicionando classes.',
    'button.click-here': 'Clique aqui',
    'button.states-text-alternate':
        'Este botão mostra um spinner durante 2 segundos e um ícone de erro durante 3 segundos antes de voltar ao estado normal. Estes estados podem ser ativados removendo ou adicionando classes.',
    'button.primary-link': 'Link primário',
    'button.link': 'Link',
    'button.primary-button': 'Botão primário',
    'button.button': 'Botão',
    'button.left': 'Esquerda',
    'button.middle': 'Meio',
    'button.right': 'Direita',
    'button.dropdown': 'Dropdown',
    'button.dropdown-link': 'Link de dropdown',

    /* 07.04. Cards */
    'cards.icon-card': 'Cartão de ícone',
    'cards.image-card': 'Cartão com imagem',
    'cards.image-overlay-card': 'Cartão com sobreposição de imagem',
    'cards.image-card-list': 'Lista de cartões com imagem',
    'cards.tab-card': 'Cartão com separadores',
    'cards.user-card': 'Cartão de utilizador',

    /* 07.05. Carousel */
    'carousel.basic': 'Carrossel básico',
    'carousel.single': 'Carrossel simples',
    'carousel.without-controls': 'Carrossel sem controlos',

    /* 07.06. Charts */
    'charts.line': 'Gráfico de linhas',
    'charts.polar': 'Gráfico polar',
    'charts.area': 'Gráfico de área',
    'charts.scatter': 'Gráfico de dispersão',
    'charts.bar': 'Gráfico de barras',
    'charts.radar': 'Gráfico radar',
    'charts.pie': 'Gráfico circular',
    'charts.doughnut': 'Gráfico de rosca',
    'charts.shadow': 'Sombra',
    'charts.no-shadow': 'Sem sombra',

    /* 07.07. Collapse */
    'collapse.basic': 'Básico',
    'collapse.toggle': 'Alternar',
    'collapse.accordion': 'Acordeão',
    'collapse.controlled': 'Controlado',
    'collapse.uncontrolled': 'Não controlado',

    /* 07.08. Dropdowns */
    'dropdowns.basic': 'Básico',
    'dropdowns.controlled': 'Controlado',
    'dropdowns.uncontrolled': 'Não controlado',
    'dropdowns.dropdown': 'Dropdown',
    'dropdowns.header': 'Cabeçalho',
    'dropdowns.action': 'Ação',
    'dropdowns.another-action': 'Outra ação',
    'dropdowns.right': 'Direita',
    'dropdowns.left': 'Esquerda',
    'dropdowns.drop-directions': 'Direções do dropdown',
    'dropdowns.dropright': 'Abrir à direita',
    'dropdowns.dropleft': 'Abrir à esquerda',
    'dropdowns.small-button': 'Botão pequeno',
    'dropdowns.large-button': 'Botão grande',
    'dropdowns.sizing': 'Tamanhos',
    'dropdowns.split-button': 'Dropdown em split',
    'dropdowns.dropup': 'Abrir em cima',

    /* 07.09. Editors */
    'editors.draftjs': 'Draft.js',
    'editors.quill-standart': 'Quill Standard',
    'editors.quill-bubble': 'Quill Bubble',

    /* 07.10. Forms */
    'forms.basic': 'Básico',
    'forms.email': 'E‑mail',
    'forms.email-muted': 'Nunca partilharemos o seu email com ninguém.',
    'forms.password': 'Palavra‑passe',
    'forms.submit': 'Submeter',
    'forms.horizontal': 'Horizontal',
    'forms.radios': 'Radios',
    'forms.first-radio': 'Primeiro rádio',
    'forms.second-radio': 'Segundo rádio',
    'forms.third-radio-disabled': 'Terceiro rádio desativado',
    'forms.checkbox': 'Checkbox',
    'forms.signin': 'Iniciar sessão',
    'forms.top-labels-over-line': 'Rótulos acima da linha',
    'forms.tags': 'Etiquetas',
    'forms.date': 'Data',
    'forms.state': 'Estado',
    'forms.top-labels-in-input': 'Rótulos no input',
    'forms.email-u': 'E‑MAIL',
    'forms.password-u': 'PALAVRA‑PASSE',
    'forms.tags-u': 'ETIQUETAS',
    'forms.date-u': 'DATA',
    'forms.state-u': 'ESTADO',
    'forms.grid': 'Grelha de formulário',
    'forms.address': 'Endereço',
    'forms.address2': 'Endereço 2',
    'forms.city': 'Cidade',
    'forms.city-message': 'Por favor, selecione uma cidade!',
    'forms.state-message': 'Por favor, selecione um distrito/estado!',
    'forms.zip': 'Código postal',
    'forms.signup': 'Registar',
    'forms.inline': 'In linha',
    'forms.validation-availity': 'Validação Reactstrap Availity',
    'forms.validation-formik': 'Validação Formik',
    'forms.default': 'Predefinido',
    'forms.firstname': 'Nome',
    'forms.firstname-message': 'Por favor, introduza o seu nome!',
    'forms.lastname': 'Apelido',
    'forms.lastname-message': 'Por favor, introduza o seu apelido!',

    /* 07.11. Form Components */
    'form-components.custom-inputs': 'Inputs personalizados',
    'form-components.checkboxes': 'Checkboxes',
    'form-components.radios': 'Radios',
    'form-components.inline': 'In linha',
    'form-components.react-select': 'React Select',
    'form-components.state-single': 'Estado único',
    'form-components.state-multiple': 'Estado múltiplo',
    'form-components.react-autosuggest': 'React Autosuggest',
    'form-components.date-picker': 'Seletor de data',
    'form-components.date': 'Data',
    'form-components.date-range': 'Intervalo de datas',
    'form-components.date-with-time': 'Data com hora',
    'form-components.embedded': 'Incorporado',
    'form-components.dropzone': 'Zona de soltar ficheiros',
    'form-components.drop-files-here': 'Solte ficheiros aqui',
    'form-components.tags': 'Etiquetas',
    'form-components.switch': 'Interruptor',
    'form-components.primary': 'Primário',
    'form-components.secondary': 'Secundário',
    'form-components.primary-inverse': 'Primário invertido',
    'form-components.secondary-inverse': 'Secundário invertido',
    'form-components.slider': 'Slider',
    'form-components.double-slider': 'Slider duplo',
    'form-components.single-slider': 'Slider simples',
    'form-components.rating': 'Classificação',
    'form-components.interactive': 'Interativo',
    'form-components.readonly': 'Somente leitura',
    'form-components.type-a-cake': 'Escreva um bolo',
    'form-components.start': 'Início',
    'form-components.end': 'Fim',
    'form-components.tables': 'Tabelas',

    /* 07.12. Icons */
    'icons.simplelineicons': 'Simple Line Icons',
    'icons.iconsmind': 'Iconsmind Icons',

    /* 07.13. Input Groups */
    'input-groups.basic': 'Básico',
    'input-groups.sizing': 'Tamanhos',
    'input-groups.small': 'Pequeno',
    'input-groups.default': 'Predefinido',
    'input-groups.large': 'Grande',
    'input-groups.checkboxes-and-radios': 'Checkboxes e radios',
    'input-groups.multiple-inputs': 'Inputs múltiplos',
    'input-groups.first-and-last-name': 'Nome e apelido',
    'input-groups.multiple-addons': 'Add-ons múltiplos',
    'input-groups.button-addons': 'Add-ons de botão',
    'input-groups.button': 'Botão',
    'input-groups.buttons-with-dropdowns': 'Botões com dropdowns',
    'input-groups.dropdown': 'Dropdown',
    'input-groups.header': 'Cabeçalho',
    'input-groups.action': 'Ação',
    'input-groups.another-action': 'Outra ação',
    'input-groups.custom-select': 'Seleção personalizada',
    'input-groups.options': 'Opções',
    'input-groups.choose': 'Escolher...',
    'input-groups.custom-file-input': 'Input de ficheiro personalizado',

    /* 07.14. Jumbotron */
    'jumbotron.hello-world': 'Olá, mundo!',
    'jumbotron.lead':
        'Esta é uma componente simples estilo jumbotron para destacar conteúdos ou informações importantes.',
    'jumbotron.lead-detail':
        'Utiliza classes utilitárias de tipografia e espaçamento para posicionar o conteúdo dentro do contêiner.',
    'jumbotron.learn-more': 'Saber mais',

    /* 07.15. Modal */
    'modal.basic': 'Básico',
    'modal.modal-title': 'Título do modal',
    'modal.launch-demo-modal': 'Lançar modal de demonstração',
    'modal.scrolling-long-content': 'Conteúdo longo com scroll',
    'modal.backdrop': 'Backdrop',
    'modal.backdrop-value': 'Valor do backdrop',
    'modal.right-modal': 'Modal à direita',
    'modal.launch-right-modal': 'Lançar modal à direita',
    'modal.nested-modal': 'Modal encadeado',
    'modal.size': 'Tamanho',
    'modal.launch-large-modal': 'Lançar modal grande',
    'modal.launch-small-modal': 'Lançar modal pequeno',

    /* 07.16. Navigation */
    'nav.basic': 'Navegação básica',
    'nav.active': 'Ativa',
    'nav.disabled': 'Desativada',
    'nav.disabled-link': 'Link desativado',
    'nav.link': 'Link',
    'nav.longer-link': 'Link mais longo',
    'nav.another-link': 'Outro link',
    'nav.right': 'Direita',
    'nav.dropdown': 'Dropdown',
    'nav.header': 'Cabeçalho',
    'nav.action': 'Ação',
    'nav.another-action': 'Outra ação',
    'nav.horizontal-alignment': 'Alinhamento horizontal',
    'nav.vertical-alignment': 'Alinhamento vertical',
    'nav.pills': 'Pills',
    'nav.fill-justify': 'Preencher e justificar',
    'nav.pills-dropdowns': 'Pills com dropdowns',
    'nav.pagination-basic': 'Paginação básica',
    'nav.pagination-sizing': 'Tamanhos de paginação',
    'nav.large': 'Grande',
    'nav.small': 'Pequeno',
    'nav.center': 'Centro',
    'nav.pagination-alignment': 'Alinhamento da paginação',
    'nav.breadcrumb-basic': 'Breadcrumb básico',


    /* 07.17. Popover & Tooltip */
    'popover-tooltip.popover': 'Popover',
    'popover-tooltip.tooltip': 'Tooltip',

    /* 07.18. Sortable */
    'sortable.columns': 'Colunas ordenáveis',
    'sortable.basic': 'Básico',
    'sortable.handles': 'Pegas',

    /* 07.19. Maps */
    'maps.google': 'Google',
    'maps.yandex': 'Yandex',

    /* 07.20. Tables */
    'table.bootstrap-tables': 'Tabelas Bootstrap',
    'table.bootstrap-basic': 'Tabela básica',
    'table.bootstrap-striped': 'Linhas alternadas',
    'table.bootstrap-bordered': 'Tabela com bordas',
    'table.bootstrap-borderless': 'Tabela sem bordas',
    'table.bootstrap-hoverable': 'Linhas com hover',
    'table.bootstrap-responsive': 'Tabela responsiva',
    'table.react-tables': 'Tabelas React',
    'table.react-pagination': 'Paginação',
    'table.react-scrollable': 'Rolável',
    'table.react-advanced': 'Filtro, tamanho e navegação',

    /* Property Info */
    'property-info.allcustomers': 'Todos os clientes',
    'property-info.external-sources': 'Fontes externas',
    'property-info.faq': 'Perguntas frequentes',
    'property-info.documents': 'Documentos',
    'property-info.publish-ai': 'Publicar IA',
    'property-info.pre-built-templates': 'Modelos pré-construídos',
    'property-info.room-types': 'Tipos de quartos',
    'property-info.about-property': 'Sobre o imóvel',
    'property-info.about-properties': 'Sobre os imóveis',
    'property-info.facilities-services': 'Instalações & serviços',
    'property-info.property-facilities': 'Instalações do imóvel',
    'property-info.room-amenities': 'Comodidades do quarto',
    'property-info.property-contact': 'Contacto do imóvel',
    'property-info.property-activities': 'Atividades do imóvel',
    'property-info.property-location': 'Localização do imóvel',
    'property-info.about-rooms': 'Quartos',
    'property-info.about-sites': 'Sobre os locais',
    'property-info.special-emergencies': 'Emergências',
    'property-info.gallery': 'Galeria',
    'property-info.policies': 'Políticas',
    'property-info.nearby': 'Nas proximidades',
    'property-info.transport': 'Transporte',
    'property-info.location': 'Localização',
    'property-info.about-rhproperty': 'Sobre lares de idosos',
    'property-info.related-topics': 'Tópicos relacionados',
    'property-info.assistant-options': 'Mensagem de boas-vindas',
    'property-info.restaurant-assistant-information': 'Informação do restaurante',
    'property-info.restaurant-assistant-options': 'Mensagem de boas-vindas',
    'property-info.channel-messages': 'Mensagens de canal',
    'property-info.icon.gallery': 'Biblioteca de ícones',
    'property-info.copilot': 'Copilot',
    'property-info.sprint': 'Sprint',
    'property-info.home-information': 'Informação da casa',
    'property-info.loction': 'Localizações',
    'property-info.rooms-and-images': 'Quartos & imagens',
    'property-info.trainig-data': 'Dados de treino IA',
    'property-info.publishMonitor': 'Publicar & Monitorizar',
    'property-info.webWidget': 'Widget web',
    'property-info.media': 'Media',
    'property-info.flows': 'Fluxos',
    'property-info.add-your-own': 'Adicionar personalizado',
    'property-info-utility-miscellaneous': 'Diversos',
    'property-info-utility-payment': 'Pagamentos',
    'property-info-utility-broadband': 'Internet fixa',
    'property-info-utility-emergency': 'Emergência',
    'property-info-utility-mobile': 'Telemóvel',
    'property-info-utility-moving': 'Mudança',
    /** Rate & Promo */
    'rate-promo.rate-plans': 'Planos tarifários',
    'rate-promo.rate-plan-addons': 'Complementos',
    'rate-promo.rate-plan-promos': 'Promoções',

    'title.property-information': 'Informação do imóvel',

    'property.message': 'Mensagem',
    'property.example': 'Exemplo',
    'property.link': 'Links',
    'property.image-carousel': 'Carrossel de imagens',
    'property.Title': 'Título',
    'property.SubTitle': 'Subtítulo',

    'property.add-invoke-api': 'Invocar API',
    'property.add-message-button': 'Adicionar mensagens',
    'property.add-img-button': 'Adicionar imagens',
    'property.add-link-button': 'Adicionar link',

    'property.add-herocard-button': 'Adicionar Hero Card',
    'property.add-api-button': 'Adicionar botões',

    'menu.settings': 'Definições',
    'menu.workflows': 'Fluxos de trabalho',
    'menu.product_services': 'Produtos & serviços',
    'menu.product_recommander': 'Recomendador de produtos',
    'menu.digital_guide_book': 'Guia digital',
    'menu.welcome_message': 'Mensagem de boas-vindas',
    'menu.about-property': 'Sobre o imóvel',
    'menu.property-facilities': 'Instalações do imóvel',
    'menu.room-amenities': 'Comodidades do quarto',
    'menu.property-contact': 'Contacto do imóvel',
    'menu.about-rooms': 'Quartos',
    'menu.special-emergencies': 'Emergências',
    'menu.show-filter': 'Filtros',
    'menu.new': 'Novo',
    'menu.channel': 'Canais',
    'menu.application': 'Aplicações',

    'dashboards.send': 'Enviar',
    'dashboards.hello': 'Olá',
    'dashboards.notificationsAllowed': 'Notificações permitidas',
    'dashboards.allowNotifications': 'Permitir notificações',
    'dashboards.views': 'Visualizações',
    'dashboards.bookingURL': 'URL de reserva',
    'dashboards.searchTags': 'Etiquetas de pesquisa',
    'dashboards.searchCategoryTags': 'Etiquetas de categoria de pesquisa',
    'dashboards.bedroom': 'Quarto',
    'dashboards.addBedroom': 'Adicionar quarto',
    'dashboards.frequency': 'Frequência',
    'dashboards.includeSubpages': 'Incluir Subpáginas',
    'dashboards.enableFaqs': 'Ativar FAQs',
    'dashboards.faqsDescription': 'Ativar FAQs permite inserir perguntas enquanto o sistema extrai respostas correspondentes do conteúdo da Página Web para criar FAQs completas',
    'dashboards.faq': 'FAQ',
    'dashboards.deleteDocument': 'Excluir Documento',
    'dashboards.confirmDelete': 'Tem certeza de que deseja excluir?',
    'dashboards.addItem': 'Adicionar Item',
    'dashboards.addFirstWebPage': 'Adicione Sua Primeira Página Web',

    'dashboards.popular-compendium': 'Itens populares do compêndio',
    'dashboards.wordcloudofcompendium': 'Nuvem de palavras do compêndio',
    'dashboards.wordcloudonthings': 'Nuvem de tópicos que os visitantes procuram & itens de menu',
    'dashboards.common-asked': 'Perguntas comuns & itens populares do menu',

    'dashboards.website-visitor-asking':
        'Coisas que os visitantes do site perguntam',
    'dashboards.visit-country': 'Visitas por país',
    'dashboards.visit-traffic': 'Origem do tráfego por país',
    'dashboards.rooms-product': 'Quartos & produtos',
    'dashboards.popular-room-product': 'Quartos e produtos populares',

    'dashboards.messenger-stats': 'Itens populares do menu',
    'dashboards.messenger-stats-topic-view': 'Estatísticas de visualizações de item de menu',
    'dashboards.messenger-stats-visits': 'Visualizações de itens de menu',
    'dashboards.opening-menu-items':
        'Número de visitantes que abriram itens de menu',

    'dashboards.number-totalavatarclick': 'Cliques no avatar total',

    'dashboards.clicks': 'Cliques',
    'dashboards.leads': 'Leads',
    'dashboards.hours': 'Horas',
    'dashboards.minutes': 'Minutos',
    'dashboards.connect': 'Ligar',
    'dashboards.ai-chatbot': 'Chatbot IA',
    'dashboards.compendium': 'Compêndio',
    'dashboards.compendium-digital-usage': 'Uso digital do compêndio',
    'dashboards.compendium-unique-visits': 'Leituras/cliques de código QR',
    'dashboards.compendium-opening-menu-items': 'Itens de menu visualizados',
    'dashboards.compendium-total-digital-clicks': 'Total de visualizações de itens do menu',
    'dashboards.compendium-total-qr-code': 'Total de leituras/cliques de código QR',
    'dashboards.compendium-avg-menu-items': 'Média de visualizações de itens de menu por varredura',


    'property.delete': 'Eliminar',
    'menu.userroles': 'Utilizadores & funções',
    'menu.members': 'Membros',
    'menu.guest-pass': 'Passes de hóspedes',
    'menu.ratebookings': 'Tarifas & reservas',
    'dashboards.engagement-time': 'Tempo de interação com assistente digital',
    'dashboards.conversations-minutes':
        'Total de minutos de conversas & nocturnas (19h–7h)',
    'dashboards.visitor-questions': 'Perguntas dos visitantes',
    'dashboards.recent-queries': 'Consultas recentes',
    'dashboards.visitor-saying':
        'O que os visitantes dizem ao assistente digital',
    'dashboards.contacts-prechatform-leavemessage':
        'Contactos guardados do formulário pré‑chat & deixar mensagem',
    'menu.dashboards': 'Insights',
    'menu.ari': 'Disponibilidade & tarifas',
    'menu.conversations': 'Conversas',
    'menu.conversations.unified-inbox': 'Caixa unificada',
    'menu.conversations.active': 'Assistente de agente',
    'menu.conversations.archives': 'Arquivos',
    'menu.conversations.missed-responses': 'Respostas perdidas',
    'menu.conversations.ticket': 'Bilhetes',
    'menu.conversations.reply-templates': 'Modelos de resposta',
    'menu.bookings': 'Reservas',
    'menu.tickets': 'Leads & bilhetes',
    'menu.propinfo': 'Central de conhecimento',
    'menu.rate-promos': 'Tarifas & promoções',
    'menu.finance': 'Finanças',
    'menu.integration': 'Conectar',
    'menu.admin': 'Admin & segurança',
    'menu.favourites': 'Favoritos',
    'menu.recommender': 'Fluxos de conversa',
    'menu.assistant-setup': 'Configuração do assistente',
    'menu.admin-insights': 'Insights administrativos',
    'menu.super-admin': 'Superadmin',
    'menu.groups': 'Grupos',
    'menu.properties': 'Imóveis',
    'menu.service-provider': 'Prestadores de serviço',
    'menu.spaces': 'Espaços',
    'menu.content-manager': 'Gestor de conteúdo',
    'menu.events-calendar': 'Calendário de eventos',
    'menu.appearance-settings': 'Aparência & definições',
    'menu.help': 'Ajuda',
    'menu.availability': 'Disponibilidade',
    'menu.myAccounts': 'As minhas contas',
    'dashboards.tickets-by-category': 'Bilhetes por categoria',
    'dashboards.download': 'Descarregar',
    'dashboards.space-booking': 'Reserva de espaço',
    'dashboards.gift-voucher': 'Vales presente',
    'dashboards.chatbots': 'Chatbots',
    'dashboards.form': 'De',
    'dashboards.to': 'Para',
    'dashboards.active-groups': 'Grupos ativos',
    'dashboards.active-properties': 'Imóveis ativos',
    'dashboards.live-properties': 'Imóveis em funcionamento',
    'dashboards.properties-going': 'Imóveis a entrar em funcionamento por período',
    'dashboards.start-date': 'Data de início',
    'dashboards.end-date': 'Data de fim',
    'dashboards.all-properties-with': 'Todos os imóveis com status ativo',
    'dashboards.aibot-by-country': 'Clientes de chatbot IA por país',
    'dashboards.list-live-clients': 'Lista de clientes ativos com chatbot IA',
    'dashboards.subscribe-to-reports': 'Subscrever relatórios',
    'dashboards.website-visits': 'Visitas ao site',
    'dashboards.unique-visitors': 'Visitantes únicos',
    'dashboards.last-week': 'Semana passada',
    'dashboards.this-week': 'Esta semana',
    'dashboards.this-month': 'Este mês',
    'dashboards.previous-month': 'Mês anterior',
    'dashboards.yeartodate': 'Ano até à data',
    'dashboards.lastyear': 'Ano passado',
    'dashboards.last-7-days': 'Últimos 7 dias',
    'dashboards.last-30-days': 'Últimos 30 dias',
    'dashboards.last-60-days': 'Últimos 60 dias',
    'dashboards.last-90-days': 'Últimos 90 dias',
    'dashboards.conversion-rates': 'Taxas de conversão',
    'dashboards.digital-assistant-engagement': 'Interação com assistente digital',
    'dashboards.total-overnight-conversations':
        'Conversas totais & noturnas (19h–7h)',
    'dashboards.percentage-accuracy': 'Precisão de compreensão',
    'dashboards.percentage-conversion': 'Conversão tráfego→chat',
    'dashboards.percentage-avatarclick': 'Cliques no avatar',
    'dashboards.percentage-negativefeedback':
        'Feedback negativo como % de cliques no avatar',
    'dashboards.percentage-amenties': 'Consultas de comodidades',
    'dashboards.percentage-booking': 'Consultas de reserva',
    'dashboards.percentage-webchats': 'Chats no site',
    'dashboards.percentage-facebookchat': 'Chats no Facebook',
    'dashboards.number-webchattime': 'Tempo total de conversa',
    'dashboards.number-totalconversation': 'Conversas totais',
    'dashboards.number-averagetimeconversation': 'Duração média por conversa',
    'dashboards.number-websiteconversation': 'Conversas no site',
    'dashboards.number-facebookconversation': 'Conversas no Facebook',
    'dashboards.number-estimatedtimesaving': 'Tempo estimado poupado',
    'dashboards.number-googlemapsconversation': 'Conversas do Google Maps',
    'dashboards.number-whatsappconversation': 'Conversas no WhatsApp',
    'dashboards.number-instagramconversation': 'Conversas no Instagram',
    'dashboards.number-agentconversation': 'Conversas com agente',
    'dashboards.number-amenityqueries': 'Consultas de comodidades',
    'dashboards.number-bookingenquiries': 'Consultas de reserva',
    'dashboards.number-groupbookingenquiries': 'Consultas de reserva de grupo',
    'dashboards.number-eventenquiries': 'Consultas de eventos',
    'dashboards.number-longstayenquiries': 'Consultas de estadia prolongada',
    'dashboards.number-totaltickets': 'Bilhetes',
    'dashboards.number-returncustomer': 'Cliente recorrente',
    'dashboards.number-redirects': 'Redirecionamentos do site',
    'dashboards.number-bookingengineleads': 'Leads do motor de reservas',
    'dashboards.number-roomnightsreferred': 'Noites de quarto referidas',
    'dashboards.number-revenuereferred': 'Receita referida',
    'menu.bookingsmenu': 'Reservas',
    'menu.guests': 'Informações do hóspede',
    'menu.whatsnew': 'Novidades',

    'menu.formbuilder': 'Construtor de formulários',
    'forms.forms-title': 'Formulário',
    "dashboards.trainAI": "Treinar IA com documentos",
    "dashboards.uploadDocuments": "Carregue documentos para ajudar a sua IA a conhecer o seu negócio e a ajudar os clientes como você faria. Pode adicionar ficheiros nos formatos .doc, .pdf ou .txt.",
    'dashboards.welcomeMessage': 'Mensagem de boas-vindas',
    'dashboards.personalizeGreeting': 'Personalize a forma como os clientes são recebidos para refletir a sua marca, estilo e etiqueta, garantindo que recebem as boas-vindas mais calorosas. Personalize as saudações para refletir a sua marca e criar um ambiente acolhedor.',
    'dashboards.addRoomDetails': 'Adicione detalhes sobre cada um dos seus quartos para que os hóspedes possam descobrir facilmente tudo o que precisam para escolher a opção perfeita e tornar o processo de reserva mais simples e rápido.',
    'dashboards.trainAIFAQs': 'Treinar IA com FAQs',
    'dashboards.manualQuestions': 'Algumas perguntas não podem ser respondidas por documentos ou encontradas no site. Aqui, você pode adicionar perguntas manualmente para garantir que os clientes sempre tenham as informações de que precisam ao seu alcance.',
    'dashboards.publishAI': 'Publique IA para refletir as atualizações mais recentes',
    'dashboards.retrainAfterChanges': 'Quando fizer alterações no Knowledge Hub ou em formulários, certifique-se de re-treinar o chatbot com as informações atualizadas. Publicar sua IA garante que o chatbot forneça as respostas mais precisas e atualizadas.',
    'dashboards.enhanceKnowledge': 'Aprimore o conhecimento da IA rastreando consultas não respondidas',
    'dashboards.reviewUnanswered': 'Sempre que a IA não puder responder a uma pergunta ou fornecer apenas detalhes limitados, você encontrará essas consultas aqui. Reveja-as para identificar lacunas no seu Knowledge Hub ou perguntas únicas dos hóspedes.',
    'dashboards.manageMedia': 'Gerenciar mídia',
    'dashboards.mediaGallery': 'Sempre que você carregar imagens como quartos, comodidades, logotipos ou seu avatar digital, elas aparecerão nesta galeria, oferecendo um local central para gerenciar visuais e garantir que seus hóspedes vejam o que torna seu negócio único.',
    'dashboards.createForms': 'Crie formulários facilmente e seja notificado a cada submissão.',
    'dashboards.manageForms': 'Crie e gerencie formulários para coletar informações de clientes, configurar notificações e personalizá-los para diferentes idiomas.',
    'dashboards.personalizeResponse': 'Personalize o estilo de resposta e como progride a conversa',
    'dashboards.controlConversation': 'Esse recurso avançado lhe dá a capacidade de moldar e controlar como as conversas se desenrolam com seus clientes em diversos canais.',

    'menu.virtualfrontdesk': 'Receção virtual',
    'menu.guestservice': 'Serviços ao h óspede',
    'virtual-front.common-questions': 'Perguntas frequentes',
    'virtual-front.add-on-upsells': 'Complementos & Upsells',
    'virtual-front.service-order': 'Ordens de serviço',
    'virtual-front.guest-service-add-on-upsells': 'Compêndio digital',
    'virtual-front.outbound': 'Saída',
    'virtual-messenger': 'Menus de widget web',

    'missed-response.missed-response-title': 'Título de resposta perdida',
    /* unified-inbox */
    'content.allconversation': 'Todas as conversas',
    'content.active': 'Ativo',
    'content.tickets': 'Bilhetes',
    'content.filter': 'Filtrar',
    'content.createtickets': 'Criar bilhetes',
    'content.conversation': 'Conversa',
    'content.knowledgesearch': 'Pesquisa de conhecimento',
    'content.reply': 'Responder',
    'content.visitorinfo': 'Informação do visitante',
    'content.callinfo': 'Informação da chamada',
    'content.allinsights': 'Todos os insights',
    'content.availabilityrates': 'Disponibilidade & tarifas',
    'content.callback': 'Chamada de retorno',
    'content.close': 'Fechar',
    'content.sms': 'SMS',
    'content.timestamp': 'Carimbo de tempo',
    'content.topics': 'Tópicos',
    'content.callingparty': 'Quem liga',
    'content.accountdomain': 'Domínio de conta',
    'content.calledparty': 'Destinatário',
    'content.recording': 'Gravação',
    'content.phonesystemoriginationcallid': 'ID de origem do sistema telefónico',
    'content.phonesystemterminationcallid': 'ID de término do sistema telefónico',
    'content.uniqueconversationid': 'ID único da conversa',
    'content.regenerateinsights': 'Regenerar insights',
    'content.customersentiment': 'Sentimento do cliente',
    'content.neutral': 'Neutro',
    'content.conversationinsights': 'Insights de conversação',
    'content.customeridverification': 'Verificação de ID do cliente',
    'content.serviceactivationdate': 'Data de ativação',
    'content.followups': 'Acompanhamentos',
    'content.actionneeded': 'Ação necessária',
    'content.uniqueConversationId': 'ID único da conversa',
    'content.uniqueChatId': 'ID único do chat',
    'content.recording&transcript': 'Gravação & transcrição',
    'content.chatinsights': 'Insights de chat',
    'content.visitedpages': 'Páginas visitadas',
    'content.deviceinfo': 'Informação do dispositivo',
    'content.chatstartedonthispage': 'Chat iniciado nesta página',
    'content.prechatinfo': 'Informação pré‑chat',
    'content.notes': 'Notas',
    'content.reassign': 'Reatribuir',
    'content.open': 'Abrir',
    "content.dismiss": "Fechar",
    "content.add_placeholder": "Adicionar valores de espaço reservado",
    "content.mobile_number": "Número de telemóvel",
    "content.please_select": "Por favor selecione",
    'content.sendwhatsapp': 'Enviar mensagem WhatsApp',

    /* Missed-response */
    'feedback.missed-question': 'Pergunta não respondida',
    'feedback.conversation-summary': 'Resumo da conversa',
    'feedback.dates-in-spanish': 'Datas têm de estar em Espanhol',
    'feedback.resolve': 'Resolver',
    'feedback.ignore': 'Ignorar',

    //integration
    // pt-PT
    'integration.select_properties': 'Selecionar Propriedades',
    'integration.select_properties_enabled': 'Selecionar as propriedades ativadas através desta integração',
    'integration.services_addons': 'Selecionar Serviços & Add-ons',
    'integration.services_visible': 'Selecionar quais serviços & add-ons serão visíveis nesta página',
    'integration.appearance': 'Aparência',
    'integration.appearance_customize': 'Escolher o nome do assistente digital, avatar e configurar as suas cores',
    'integration.booking_calendar': 'Calendário de Reservas',
    'integration.booking_calendar_style': 'Escolher o estilo do pop-up do calendário de reservas',
    'integration.nudges': 'Lembretes',
    'integration.nudges_setup': 'Configurar mensagens proativas para envolver visitantes do site',
    'integration.position': 'Posição',
    'integration.position_control': 'Controlar a posição do widget de chat no seu site',
    'integration.custom_fonts': 'Fontes Personalizadas',
    'integration.custom_fonts_upload': 'Carregar quaisquer fontes personalizadas que queira usar na página',
    'integration.custom_css': 'CSS Personalizado',
    'integration.custom_css_usage': 'Usar CSS para personalizar o seu Compêndio Digital',
    'integration.location': 'Localização',
    'integration.location_embed': 'Adicionar o URL de incorporação da localização',
    'integration.external_links': 'Links Externos',
    'integration.external_links_add': 'Adicionar os seus links',
    'integration.language': 'Língua',
    'integration.widget_languages': 'Selecionar os idiomas para o widget de chat',
    'integration.chatbot_contact': 'Chatbot',
    'integration.chatbot_enable': 'Ativar o seu assistente digital',
    'integration.chatbot_security': 'Manter o seu Messenger seguro',
    'integration.chatbot_trusted_pages': 'Listar páginas confiáveis para mostrar o Chatbot',
    'integration.chatbot_publish': 'Publicar o seu assistente digital',
    'integration.chatbot_install': 'Copiar o snippet de código para instalar o seu assistente digital',

    'menu.guest-messaging': 'Mensagens de hóspedes',
    'guest-messaging.settings': 'Configurações',
    'guest-messaging.outreach-setup': 'Configuração de outreach',
    'guest-messaging.reservations': 'Reservas',
    'guest-messaging.insights_logs': 'Informações e registos',
    'guest-messaging.placeholder': 'O módulo Mensagens de hóspedes estará disponível em breve.',
    'guest-messaging.settings.placeholder': 'Configure as preferências de mensagens para hóspedes.',
    'guest-messaging.outreach.placeholder': 'Configure campanhas e modelos de outreach.',
    'guest-messaging.reservations.placeholder': 'Gerencie mensagens relacionadas a reservas.',
    'guest-messaging.reservation-source': 'Fonte de dados da reserva',
    'guest-messaging.communication-channels': 'Canais de comunicação',
    'guest-messaging.templates': 'Modelos',
    'guest-messaging.link': 'Link',
    'guest-messaging.business-profile': 'Perfil empresarial',

};
export default ptMessages;